export default "__VITE_ASSET__BvlCCeV$__"